import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BannerService } from '../../servicios/banner.service';
import SwiperCore, { Autoplay, Pagination, Navigation, SwiperOptions } from 'swiper/core';

SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: 'app-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PromocionesComponent implements OnInit {

  banners: any[] = [];

  swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    loop: true,
    autoplay: { delay: 4000, disableOnInteraction: false },
    pagination: { clickable: true },
    navigation: false,
    grabCursor: true
  };

  constructor(private bannerService: BannerService) { }

  ngOnInit(): void {
    this.bannerService.getBanners().subscribe((res: any) => {
      let data = res;
      if (res && res.data && Array.isArray(res.data)) {
        data = res.data;
      } else if (res && res.response && Array.isArray(res.response)) {
        data = res.response;
      }
      
      if (Array.isArray(data)) {
        this.banners = data.filter((item: any) => item.imagenes && item.imagenes.web);
      }
    });
  }

}
